import { Container } from '../CurrentUsers.styles';

const MembersError = () => {
  return <Container>Error on load members</Container>;
};

export { MembersError };
